export const INITIALIZING = 'INITIALIZING';
export const LOADING = 'LOADING';
export const EMPTY = 'EMPTY';
export const NO_RESULTS = 'NO_RESULTS';
export const ERROR = 'ERROR';
export const HAS_RESULTS = 'HAS_RESULTS';